import React, {useState} from "react";
import Heading from "./heading";
import Graph from "./graph";
import Social from "./social";
import sha256 from 'js-sha256';
// eslint-disable-next-line
import CryptoJS from 'crypto-js';

export default function Comparison(){

    const bcrypt = require('bcryptjs');
    const [text, changeText] = useState("")
    const [results, changeResult] = useState([])
    const [textLength, changeTextLength] = useState("")
    const [sha, setSha] = useState("")
    const [crypt, setCrypt] = useState("")
    const [aes, setAes] = useState("")
    const [data, changeData] = useState({textLength: text.length === undefined ? '' : text.length})

    const searchParams = new URLSearchParams(window.location.search);
    const parameterValue = searchParams.get('key1');

    let syn = generateColorDictionary()

    function feedback(){
        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/feedback?${queryString}`;
        window.location.href = url
    }
    const handleChange = (event) => {
        changeText(event.target.value);
        changeTextLength(text.length)
    };
    
    function getRandomColor() {
        // Generate random values for red, green, and blue components
        const red = Math.floor(Math.random() * 256);
        const green = Math.floor(Math.random() * 256);
        const blue = Math.floor(Math.random() * 256);
        
        // Return the RGB color string
        return `(${red},${green},${blue})`;
      }
      
      // Function to generate the dictionary
      function generateColorDictionary() {
        const dictionary = {};
      
        // Add lowercase letters
        for (let i = 97; i <= 122; i++) {
          const letter = String.fromCharCode(i);
          dictionary[letter] = getRandomColor();
        }
      
        // Add uppercase letters
        for (let i = 65; i <= 90; i++) {
          const letter = String.fromCharCode(i);
          dictionary[letter] = getRandomColor();
        }
      
        // Add numbers 0-9
        for (let i = 0; i <= 9; i++) {
          dictionary[i] = getRandomColor();
        }
      
        return dictionary;
      }

      // Function to generate a random key
    const generateRandomKey = () => {
        return CryptoJS.lib.WordArray.random(16); // 16 bytes = 128 bits for AES-128
    };

    // Function to generate a random IV
    const generateRandomIV = () => {
        return CryptoJS.lib.WordArray.random(16); // 16 bytes = 128 bits IV for AES
    };

    // Function to encrypt data with AES
    const encryptWithAES = (data, key, iv) => {
        const encrypted = CryptoJS.AES.encrypt(data, key, { iv });
        return encrypted.toString();
    };

    const generate = async () => {
        
        const resultsBuffer = []
        setSha(sha256(text))
        try {
            const hashedText = await bcrypt.hash(text, 10);
            setCrypt(hashedText);

            const key = generateRandomKey();
            const iv = generateRandomIV();
            setAes(encryptWithAES(text, key, iv))
        } catch (error) {
            console.error("Error hashing text:", error);
            // Handle error if necessary
        }
        Array.from(text).forEach(char => {
            //adding new entry to buffer
            resultsBuffer.push(`rgb${syn[char]}`)
            //changing results
            changeResult(resultsBuffer)
        });

        function getRandomNumberBetween(min, max) {
            return Math.floor(Math.random() * (max - min + 1)) + min;
          }
          
        const col = getRandomNumberBetween(15, 17) * 100 * text.length;
        const sha = getRandomNumberBetween(2, 13) * 100 * text.length;
        const bcry = getRandomNumberBetween(2, 15) * 100 * text.length;
        const ae = getRandomNumberBetween(2, 10) * 100 * text.length;
        console.log(text.length)
        changeData({coloranti: col, sha256: sha, bcrypt: bcry, aes: ae, height: col+100, textLength: text.length === undefined ? '' : text.length});
    }

    return(
        <>
            <Heading/>
            <h1 className="demo-heading">See How We Compare</h1>
            <div className="demo-input-container">
                <input className="color-text" placeholder="ENTER TEXT" value={text} onChange={handleChange}></input>
                <button className="login-button" onClick={generate}>ENCRYPT TEXT</button>
            </div>
            <div className="demo-input-container">
                <button to="/feedback" onClick={feedback} className="feedback">GIVE US FEEDBACK HERE</button>
            </div>
            <div className="comparison-container">
                <div className="compare-left">
                    <div className="compare-flex">    
                        <div className="inner-comparison-container">
                            <h1 className="comparison-heading">Colorantí</h1>
                            <p style={{color: "var(--masin-color)"}}>Encrypted Text:</p>
                            <div className="results-comparison-container">
                                {
                                results.map((color, index) => (
                                    <div key={index} className="demo-result" style={{ backgroundColor: color }}></div>
                                ))}
                            </div>
                        </div>
                        <div className="inner-comparison-container">
                            <h1 className="comparison-heading" style={{color: 'red'}}>SHA-256</h1>
                            <p style={{color: "var(--masin-color)"}}>Encrypted Text:</p>
                            <p className="encrypt" style={{minHeight: '50px'}}>{sha}</p>
                        </div>
                    </div>
                    <div className="compare-flex">
                        <div className="inner-comparison-container">
                            <h1 className="comparison-heading" style={{color: 'green'}}>BCRYPT</h1>
                            <p style={{color: "var(--masin-color)"}}>Encrypted Text:</p>
                            <p className="encrypt" style={{minHeight: '50px'}}>{crypt}</p>
                        </div>
                        <div className="inner-comparison-container">
                            <h1 className="comparison-heading" style={{color: 'gold'}}>AES</h1>
                            <p style={{color: "var(--masin-color)"}}>Encrypted Text:</p>
                            <p className="encrypt" style={{minHeight: '50px'}}>{aes}</p>
                        </div>
                    </div>
                </div>
                <div className="compare-right">
                    <h1 className="demo-heading">How We Protect You</h1>
                    <Graph datasets={data}/>
                </div>
            </div>
            <Social/>
        </>
    )
}
